import { render, staticRenderFns } from "./BaseROInputWrap.vue?vue&type=template&id=15ee478b&scoped=true"
import script from "./BaseROInputWrap.vue?vue&type=script&lang=js"
export * from "./BaseROInputWrap.vue?vue&type=script&lang=js"
import style0 from "./BaseROInputWrap.vue?vue&type=style&index=0&id=15ee478b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ee478b",
  null
  
)

export default component.exports